
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import { FoodItem, RecipeFoodItemInfo } from "@/types/pantry";

export default defineComponent({
  name: "PantryFoodItem",
  props: {
    foodId: {
      type: Number,
      default: null,
      required: true
    },
    icon: {
      type: String,
      default: null,
      required: true
    },
    name: {
      type: String,
      default: "",
      required: true
    },
    recipeFoodItem: {
      type: RecipeFoodItemInfo,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const clickFood = () => {
      const item = new FoodItem(props.name, props.icon, props.foodId, props.recipeFoodItem ? props.recipeFoodItem : null);
      context.emit("select-food", item);
    };
    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("PantryFoodItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("PantryFoodItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    return {
      clickFood,
      onImageError
    };
  }
});
